const baseURL_ODOO = 'https://erp.intercomservicios.com';
const db_ODOO = "production_npl"
const TIMEOUT = 60000 // 10 segundos de timeout

export { baseURL_ODOO, db_ODOO, TIMEOUT }